import { TextField } from 'react95';
import { useLocale } from '../i18n/LocaleContext';
import {
  Avatar,
  Link,
  ProfileFields,
  ProfileHeader,
  SectionTitle,
} from './ui';

const Profile = ({ data }) => {
  const { t } = useLocale();
  const labels = t.profile;

  return (
    <>
      <ProfileHeader>
        <Avatar
          src={`${process.env.PUBLIC_URL}/photo.jpg`}
          alt={`${labels.photoAlt}: ${data.name}`}
        />
        <ProfileFields>
          <TextField
            fullWidth
            readOnly
            value={data.name}
            aria-label={labels.name}
            style={{ marginBottom: '10px' }}
          />
          <TextField
            fullWidth
            readOnly
            value={data.position}
            aria-label={labels.position}
          />
        </ProfileFields>
      </ProfileHeader>

      <SectionTitle>{labels.about}</SectionTitle>
      <p>{data.about}</p>

      <SectionTitle>{labels.contacts}</SectionTitle>
      <p>
        <strong>{labels.email}: </strong>
        <Link href={`mailto:${data.email}`}>{data.email}</Link>
      </p>
      <p>
        <strong>{labels.phone}: </strong>
        <Link href={`tel:${data.phone.replace(/[^\d+]/g, '')}`}>{data.phone}</Link>
      </p>
      <p>
        <strong>{labels.telegram}: </strong>
        <Link href={data.telegram} target="_blank" rel="noopener noreferrer">
          {data.telegram}
        </Link>
      </p>
      <p>
        <strong>{labels.gitlab}: </strong>
        <Link href={data.gitlab} target="_blank" rel="noopener noreferrer">
          {data.gitlab}
        </Link>
      </p>
    </>
  );
};

export default Profile;
